import { moment } from "@packages/ui/libs";
import { useData } from "@providers/context";

export const timeZoneDateTimeUser = ({
  date,
  format,
}: {
  date: any;
  format: string;
}): string | "-" => {
  const { userData } = useData();

  const zoneFormatAll =
    userData?.user?.timezone &&
    userData?.user?.timezone?.substring(
      userData?.user?.timezone?.indexOf(")") + 2
    );
  const timezoneUpdate = userData?.user?.timezoneUpdate;
  const getTimezone = (): string => {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  };
  const timezoneLocal = getTimezone();

  return date
    ? moment(date)
        ?.tz(timezoneUpdate ? timezoneLocal : zoneFormatAll)
        ?.format(format)
    : "-";
};
